import { render, staticRenderFns } from "./MenuElement.vue?vue&type=template&id=6d7010a6&"
import script from "./MenuElement.vue?vue&type=script&lang=js&"
export * from "./MenuElement.vue?vue&type=script&lang=js&"
import style0 from "./MenuElement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports